<template>
  <div class="registration" v-loading="loading">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconPro.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>皮肤科-手术登记表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="日期">
          <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="类别">
          <el-select v-model="filters.category" clearable="" placeholder="选择类别">
            <el-option v-for="(item,index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院区">
          <el-select v-model="filters.areaName" placeholder="请选择院区" style="width:90%">
            <el-option v-for="item in areaOptions" :key="item.value" :label="item.menuName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <div class=" buttonText">
        <div class="delete" @click="exportData">导出皮肤科手术表</div>
        <div class="addData" @click="exportForm">导出登记表</div>
        <div class="addData" @click="add">新增皮肤科登记表</div>
        <div class="addData" @click="del" v-if="empId==1">删除</div>
      </div>
    </div>
    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :height="tableHeight" :header-cell-style="{color:'#626365'}" :row-class-name="tableRowClassName">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="time" label="日期" width="100"></el-table-column>
        <el-table-column prop="clientCard" label="客户卡号"></el-table-column>
        <el-table-column prop="clientName" label="姓名"></el-table-column>
        <el-table-column prop="clientSex" label="性别"></el-table-column>
        <el-table-column prop="clientAge" label="年龄"></el-table-column>
        <el-table-column prop="diagnosis" label="诊断"></el-table-column>
        <!-- <el-table-column prop="injectionProductName" label="注/假名称" width="150"></el-table-column> -->
        <el-table-column prop="" label="注/假名称" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.injectionProductList" :key="index">
              <span class="sp">{{item.productName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="标准规格" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.injectionProductList" :key="index">
              <span class="sp">{{item.specification}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="injectionPart" label="处理"></el-table-column>
        <el-table-column prop="curePart" label="处理(标准)"></el-table-column>
        <el-table-column prop="anesthesiaMode" label="麻醉"></el-table-column>
        <el-table-column prop="assistantName" label="医助"></el-table-column>
        <el-table-column prop="anesthetistName" label="麻醉师"></el-table-column>
        <el-table-column prop="anesthesiaTime" label="麻醉时间" width="100"></el-table-column>
        <el-table-column prop="nurseName" label="巡回护士"></el-table-column>
        <el-table-column prop="clientMobile" label="联系方式">
          <template slot-scope="scope">
            <div>
              <div v-for="(item,index) in scope.row.clientMobile.replaceAll('，', ' ').split(' ')" :key="index">
                {{item?item!='无'?item.replace(item.substr(3,4), '****'):'无':''}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="doctorName" label="手术医生"></el-table-column>
        <el-table-column prop="partDoctor" label="处方医生"></el-table-column>
        <el-table-column prop="opear" label="实际手术医生"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="" label="剩余注射产品"></el-table-column>
        <el-table-column prop="injectionNumber" label="支数"></el-table-column>
        <el-table-column prop="" label="注射金额"></el-table-column>
        <el-table-column prop="" label="手术金额"></el-table-column>
        <el-table-column prop="" label="麻醉金额"></el-table-column>
        <el-table-column prop="channel" label="渠道"></el-table-column>
        <el-table-column prop="serviceName" label="客服"></el-table-column>
        <el-table-column prop="" label="手术分类"></el-table-column>
        <el-table-column prop="category" label="类别"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" :disabled="scope.row.timeIdentification == true?true:false">编辑</el-button>
            <el-button size="mini" type="warning" @click="handleLog(scope.$index, scope.row)" :disabled="scope.row.identification == 0?true:false">日志</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增皮肤科登记表弹框 -->
    <addSkin v-if="dialogForm" ref="addSkin" @add-comment="appendComment"></addSkin>
    <!-- 编辑皮肤科登记表弹框 -->
    <editSum v-if="editSum" ref="editSum" :formData="formData" @add-comment="appendComment"></editSum>
    <!-- 查看日志弹窗 -->
    <el-dialog title="日志" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column prop="createBy" label="操作人" width="150"></el-table-column>
        <el-table-column prop="updateTime" label="操作时间" width="200"></el-table-column>
        <el-table-column prop="operateType" label="操作类型"></el-table-column>
        <el-table-column prop="operateDetails" label="操作内容"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import addSkin from "./addSkin.vue";
import editSum from "./editSum.vue";
export default {
  components: {
    // 新增弹框
    addSkin,
    editSum,
  },
  data() {
    return {
      formData: {},
      gridData: [],
      dialogTableVisible: false,
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      options: [{
        label: '全部 ',
        value: '内外'
      }, {
        label: '内',
        value: '内'
      }, {
        label: '外',
        value: '外'
      },],
      tableData: [],
      dialogForm: false,
      loading: false,
      editSum: false,
      empId: Lockr.get("empId"),
      areaOptions: [
        {
          id: '全部',
          menuName: '全部'
        },
        {
          id: '伯思立',
          menuName: '伯思立'
        }, {
          id: '百达丽',
          menuName: '百达丽'
        }, {
          id: '翡立思',
          menuName: '翡立思'
        }
      ],
      tableHeight: ''
    }
  },
  methods: {

    // 表格不同行设置不同的样式
    tableRowClassName({
      row,
      rowIndex
    }) {
      if (row.identification == 1) {
        return 'warningRed';
      }
      return '';
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // 新增注射科登记表
    add() {
      this.dialogForm = true;
      this.$nextTick(() => {
        this.$refs.addSkin.openDialog1Visible();
        this.$refs.addSkin.openLoading();
      });
    },
    search() {
      this.filters.pagination.page = 1
      this.refresh()
    },
    // 查询
    query(page) {
      this.loading = true
      let querys = {
        startTime: "",
        endTime: "",
        page: page,
        size: this.filters.pagination.limit,
        category: this.filters.category,
        jurisdictionId: Lockr.get("jurisdictionId"),
        jurisdictionName: Lockr.get("jurisdictionName"),
        createBy: this.empId,
        areaName: this.filters.areaName
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      api.requestQuiet("/register/findDermatologyOperationPage", querys, (res) => {
        // console.log(res)
        var data = res.data.list;
        this.tableData = data
        this.tableData.forEach(ele => {
          ele.assistantName = '/'
          ele.anesthesiaTime = '/'
          ele.opear = '/'
          ele.practicalOperation = '/'
        });
        this.filters.pagination.total = parseInt(res.data.count);
        this.loading = false
      }, (err) => { });
    },
    appendComment(item) {
      this.query(this.filters.pagination.page);
    },
    // 导出皮肤科登记表数据
    exportData() {
      let exportUrl = axios.defaults.baseURL;
      var register = {
        total: this.filters.pagination.total,
        category: this.filters.category,
        areaName: this.filters.areaName
      }
      if (this.filters.startTime) {
        register.startTime = this.filters.startTime[0]
        register.endTime = this.filters.startTime[1]
      }
      var formData = new FormData();
      formData.append("register", JSON.stringify(register))
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "register/excelOperationRegister", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "皮肤科手术表数据.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportForm() {
      let exportUrl = axios.defaults.baseURL;
      var register = {
        total: this.filters.pagination.total,
        category: this.filters.category,
        areaName: this.filters.areaName
      }
      if (this.filters.startTime) {
        register.startTime = this.filters.startTime[0]
        register.endTime = this.filters.startTime[1]
      }
      var formData = new FormData();
      formData.append("register", JSON.stringify(register))
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "register/excelDermatologyDepartmentRegister", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              console.log(res)
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "皮肤科登记表数据.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 查看日志
    handleLog(index, row) {
      this.dialogTableVisible = true
      // 根据id查询当条日志
      let querys = {
        operateType: '美容皮肤科手术表',
        registerId: row.dermatologyRegisterId
      }
      api.request("/register/findRegisterLogById", querys, (res) => {
        console.log(res)
        this.gridData = res.data;
      });
    },
    // 编辑
    handleEdit(index, row) {
      console.log(row)
      console.log("row.id")
      console.log(row.dermatologyRegisterId)
      this.editSum = true;
      // 根据id查询详情
      let querys = {
        dermatologyRegisterId: row.dermatologyRegisterId
      }
      api.request("/register/findDermatologyRegisterById", querys, (res) => {
        console.log(res)
        this.formData = res.data;
        console.log(this.formData.registerInformationDtoList);
        this.formData.registerInformationDtoList.forEach(ele => {
          if (ele.partDoctor) {
            ele.partDoctor = ele.partDoctor.split(',')
          }
          if (ele.dutyNurse) {
            ele.dutyNurse = ele.dutyNurse.split(',')
          }
        })
        this.formData.operationMaterials.forEach(ele => {
          ele.injectionProductList.forEach(item => {
            item.injectionPart = item.injectionPart.split(',')
          });
        })

      });
      this.$nextTick(() => {
        this.$refs.editSum.openDialog1Visible();
        this.$refs.editSum.openLoading();
      });
    },
    del() {
      var data = this.multipleSelection;
      var id = [];
      data.map(function (item, index) {
        id.push(item.dermatologyRegisterId);
      });
      this.$confirm("确定要删除选中的数据吗？", "删除项目", {
        center: true,
      })
        .then((res) => {
          api.requestQuiet("/register/deleteDermatologyRegisterById", { dermatologyRegisterId: id.toString() },
            (res) => {
              if (res.result == true) {
                _g.toast("success", "删除成功");
                this.query(this.filters.pagination.page);
              } else {
                _g.toast("error", "删除失败");
                this.query(this.filters.pagination.page);
              }
            }, (err) => { }
          );
        })
        .catch((err) => {
          // this.$message.error('删除失败！');
        });
    },
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 350
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page);
  },
  watch: {
    $route(to, from) {
      this.query(this.filters.pagination.page);
    },
  },
}
</script>
<style scoped>
@import "../../assets/css/main.css";
.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}
.el-table >>> .warningRed {
  color: #f56c6c;
}
</style>